import { isUsable } from "@nova/constants"
import { ColorFinderImage } from "@nova/protobuf"
import { VideoMetadata } from "@nova/slice-video"
import { selectColorFinderImagesAndUploadsByFlightId } from "features/entity-caching/images/colorfinder/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { ColorFinderState } from "plugins/ColorFinder/ImageColorFinder/ImageColorFinderSlice"
import { useMemo } from "react"
import { GenericFlightPathAssetsThumbnail } from "../generics/genericAssetsListThumbnails"
import { selectImageColorFinderFlightById } from "features/entity-caching/flights/selectors"

export function ImageColorfinderAssetsThumbnail({ id }: { id: string }) {
    const metadata = useImageColorfinderMetadata({ id })
    return (
        <GenericFlightPathAssetsThumbnail
            id={id}
            selectEntity={selectImageColorFinderFlightById}
            getMetadata={async () => metadata}
        />
    )
}

function useImageColorfinderMetadata({ id }: { id: string }) {
    const uploads = useAppSelector(selectColorFinderImagesAndUploadsByFlightId(id))
    const usableUploads = useMemo(() => {
        const usableUploads: (ColorFinderImage | ColorFinderState)[] = []
        uploads?.forEach((upload) => {
            const usableUpload = isUsable(upload)
            if (usableUpload) usableUploads.push(usableUpload)
        })
        return usableUploads.sort((a, b) =>
            (a.takenAt || "") < (b.takenAt || "") ? -1 : a.takenAt === b.takenAt ? 0 : 1
        )
    }, [uploads])
    const data = useMemo(() => {
        const data: VideoMetadata = []
        usableUploads.forEach((upload) => {
            if (upload.longitude) {
                data.push([
                    upload.longitude,
                    upload.latitude ?? NaN,
                    upload.height ?? NaN,
                    upload.pitch ?? NaN,
                    upload.yaw ?? NaN,
                    upload.roll ?? NaN,
                    upload.fov ??
                        ("focalLength" in upload && upload.focalLength ? upload.focalLength : NaN),
                    upload.altitude ?? NaN,
                ])
            }
        })
        return data
    }, [usableUploads])
    return data
}
